import en from "./en.json";
import es from "./es.json";

export const locales = {
  en,
  es,
};
